var map = {
	"./brushed_metal.fs": 171,
	"./from_taiwan.fs": 173,
	"./simple_texture.fs": 175,
	"./wood.fs": 177
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;



//////////////////
// WEBPACK FOOTER
// ./src/shaders ^\.\/.*\.fs$
// module id = 204
// module chunks = 5